import React from 'react'
import { NavLink, useParams } from 'react-router-dom';
import Container from '../components/Container'
import Fancybox from '../components/FancyBox';
import { news } from '../constants/data/news';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

const SingleNews = () => {

  const { id } = useParams();
  const {title, description, images} = news.find(item => item.id == id);

  return (
    <>
      <Container>
        <div className="max-w-screen-xl mx-auto px-3">
          <div className="text-center mb-10">
            <h2 className="text-primary text-lg font-bold tracking-tight">الأخبار و التقارير الإعلامية</h2>
            <h1 className="text-2xl font-bold tracking-tight text-gray-900 mt-6 text-primary font-bold">{title}</h1>
          </div>

          <div>
            <ul className="text-base">
              <li className="inline-block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-4 inline-block text-green-600 ml-2"
                >
                  <path
                    fillRule="evenodd"
                    d="M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z"
                    clipRule="evenodd"
                  />
                </svg>

                <NavLink to="/" className="text-primary font-bold">الرئيسية</NavLink>
              </li>
              <li className="inline-block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-4 inline-block text-green-600"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L12.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z"
                    clipRule="evenodd"
                  />
                  <path
                    fillRule="evenodd"
                    d="M4.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L6.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z"
                    clipRule="evenodd"
                  />
                </svg>

                <NavLink to='/news' className="text-gray-700 font-bold">الأخبار والتقارير الإعلامية</NavLink>
              </li>
            </ul>
          </div>

          <div className="shadow-[0_0_5px_rgba(0,0,0,0.2)] p-4 md:p-10 -shadow-lg rounded my-4 md:my-8">
            <p>{description}</p>
          </div>
          <div>
            <h3 className="mt-6 mb-4 text-primary font-bold">البوم الصور</h3>
            <Fancybox
              options={{
                Carousel: {
                  infinite: true,
                },
              }}
            >
              <ResponsiveMasonry
                columnsCountBreakPoints={{350: 1, 750: 2, 900: 3}}
                
              >
                <Masonry gutter={10}>
                  {images.map((item, index) => (
                    <a
                      key={index}
                      data-fancybox="gallery"
                      href={item}
                      className='w-fit block'
                    >
                      <img
                        alt=""
                        src={item}
                        width='100%'
                        height='auto'
                      />
                    </a>
                  ))}
                </Masonry>
              </ResponsiveMasonry>
            </Fancybox>
          </div>
        </div>
      </Container>
    </>
  )
}

export default SingleNews